var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 57C81 52.5817 84.5817 49 89 49H127V103H89C84.5817 103 81 99.4183 81 95V57Z",
    fill: "#4C6170"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 49,
    width: 46,
    height: 54,
    fill: "#4C6170"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193 49H231C235.418 49 239 52.5817 239 57V95C239 99.4183 235.418 103 231 103H193V49Z",
    fill: "#4C6170"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.616 73.6992L205.353 84.2908L183.501 113.572L160.616 73.6992Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M188.941 88.8189L215.999 109.011L210.229 116.742L183.171 96.5498L188.941 88.8189Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.549 67.6782L212.202 81.8013L202.91 94.2524L221.597 108.198L211.043 122.34L192.356 108.395L183.064 120.846L152.549 67.6782ZM191.543 102.797L210.229 116.742L215.999 109.011L197.312 95.0658L205.353 84.2904L160.616 73.6988L183.501 113.572L191.543 102.797Z",
    fill: "#4C6170"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#9B1926"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonGroup);
export default __webpack_public_path__ + "static/media/button-group.b0341b288be465dd8645be72bef62ea2.svg";
export { ForwardRef as ReactComponent };